import React from 'react';

interface GetBambooFluentIconProps {
  icon: React.ReactNode;
}

export default function BambooFluentIcon({ icon }: GetBambooFluentIconProps) {
  return <span className="anticon bamboo-icon">{icon}</span>;
}
